export default __webpack_public_path__ + "static/media/video.64d1adf5.svg";